/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import ServicePath from "@/core/ServicePath";
import { MainRequest } from "@/core/request";

export default class PacsConfigurationRequest extends MainRequest {

    static addPacsConfigurations(data) {
        return this.postSEC(ServicePath.PACS_CONFIGURATION_ADD, data);
    }

    static listAllPacsConfigurations(){
        return this.getSEC(ServicePath.PACS_CONFIGURATION_LIST_ALL)
    }    
    
    static updatePacsConfigurations(data){
        return this.postSEC(ServicePath.PACS_CONFIGURATION_LIST_ALL, data)
    }    
    
    static deletePacsConfigurations(data){
        return this.postSEC(ServicePath.PACS_CONFIGURATION_LIST_ALL, data)
    }

    static listPacsConfigurationsByBranchOffice(data){
        return this.postSEC(ServicePath.PACS_CONFIGURATION_LIST_BY_BRANCHOFFICE, data);
    }

    static addAddendumsConfiguration(data){
        return this.postSEC(ServicePath.CONFIGURATION_ADD_ADDENDUMS, data);
    }

    static listConfigurationsByBranchOffice(data){
        return this.postSEC(ServicePath.CONFIGURATION_ALL_CONFIG, data);
    }

    static listAddendumConfigurationsByBranchOffice(data){
        return this.postSEC(ServicePath.CONFIGURATION_ADDENDUMS_BY_BRANCH, data);
    }
    static getLicense(){
        return this.getSEC(ServicePath.CONFIGURATION_GET_LICENSE);
    }
    static addDateLicense(data){
        return this.postSEC(ServicePath.CONFIGURATION_ADD_LICENSE, data);
    }
    static getConfigAppReport(data){
        return this.postSEC(ServicePath.CONFIGURATION_GET_REPORT_APP, data);
    }
    static addConfigAppReport(data){
        return this.postSEC(ServicePath.CONFIGURATION_ADD_REPORT_APP, data);
    }
    static addConfigReception(data){
        return this.postSEC(ServicePath.CONFIGURATION_ADD_CONFIG_RECEPTION, data);
    }
    static getConfigReception(data){
        return this.postSEC(ServicePath.CONFIGURATION_GET_CONFIG_RECEPTION, data);
    }

}